import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=07486f03&lang=pug&"
import script from "./actions.vue?vue&type=script&lang=js&"
export * from "./actions.vue?vue&type=script&lang=js&"
import style0 from "./actions.vue?vue&type=style&index=0&id=07486f03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports